<section *ngIf="offres.length !== 0" class="motivation-courses-area bg-FAF8F8 pt-100 pb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">COURS</span>
            <h2>Nos offres</h2>
        </div>
        <div class="row justify-content-center">
            <div *ngFor="let element of offres" class="col-lg-4 col-md-6">
                <div class="single-motivation-courses-box mb-30">
                    <div class="courses-image">
                        <a class="d-block"><img src="assets/images/aboutitem.png" alt="image"></a>
                        <!-- <a routerLink="/single-courses" class="d-block"><img src="assets/img/motivation-course/courses/courses-1.jpg" alt="image"></a> -->
                        <div class="price">{{ element.offre.id }} FCFA</div>
                    </div>
                    <div class="courses-content">
                        <div class="courses-tag">
                            <a routerLink="/" class="d-block">{{ element.offre.typeOffre.nom }}</a>
                        </div>
                        <div class="course-author d-flex align-items-center justify-content-between">
                            <div class="author-box">
                                <span *ngFor="let tag of element.criteres">
                                    <p-tag [style]="{ 'background': 'gray', 'margin-left': '1px'}" [value]="tag.valeur"></p-tag>
                                    <!-- <p-tag severity="success" [value]="tag.valeur"></p-tag> <span> </span> -->
                                </span>
                            </div>
                        </div>
                        <h3><a  class="d-inline-block">{{ element.offre.nom }}</a></h3>
                    </div>
                    <div class="courses-box-footer">
                        <!-- <ul>
                            <li class="students-number">
                                <i class='bx bx-user'></i> 20 étudiants
                            </li>
                            <li class="courses-lesson">
                                <i class='bx bx-book-open'></i> 10 thématiques
                            </li>
                            <li class="courses-time">
                                <i class='bx bx-time-five'></i> 10 Jours
                            </li>
                        </ul> -->
                        <span>
                            {{ element.offre.description }}
                        </span>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-motivation-courses-box mb-30">
                    <div class="courses-image">
                        <a routerLink="/single-courses" class="d-block"><img src="assets/images/banniere.jpg" alt="image"></a>
                        <a routerLink="/single-courses" class="d-block"><img src="assets/img/motivation-course/courses/courses-2.jpg" alt="image"></a>
                        <div class="price">FCFA</div>
                    </div>
                    <div class="courses-content">
                        <div class="courses-tag">
                            <a routerLink="/" class="d-block">BUSINESS</a>
                        </div>
                        <div class="course-author d-flex align-items-center justify-content-between">
                            <div class="author-box">
                                <img src="assets/img/user2.jpg" class="rounded-circle mr-2" alt="image">
                                <span>Kimberly Joseph</span>
                            </div>
                            <div class="courses-rating">
                                <div class="review-stars-rated">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                </div>
                                <div class="rating-total">(0 Rating)</div>
                            </div>
                        </div>
                        <h3><a routerLink="/single-courses" class="d-inline-block">React – The Complete Guide (React, Router, Redux)</a></h3>
                    </div>
                    <div class="courses-box-footer">
                        <ul>
                            <li class="students-number">
                                <i class='bx bx-user'></i> 9 étudiants
                            </li>
                            <li class="courses-lesson">
                                <i class='bx bx-book-open'></i> 7 thématiques
                            </li>
                            <li class="courses-time">
                                <i class='bx bx-time-five'></i> 1 Heure
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-4 col-md-6">
                <div class="single-motivation-courses-box mb-30">
                    <div class="courses-image">
                        <a routerLink="/single-courses" class="d-block"><img src="assets/images/LAbecedaire-des-institutions_la-formation-professionnelle.jpg" alt="image"></a>
                        <a routerLink="/single-courses" class="d-block"><img src="assets/img/motivation-course/courses/courses-3.jpg" alt="image"></a>
                        <div class="price">FCFA</div>
                    </div>
                    <div class="courses-content">
                        <div class="courses-tag">
                            <a routerLink="/" class="d-block">DEVELOPMENT</a>
                        </div>
                        <div class="course-author d-flex align-items-center justify-content-between">
                            <div class="author-box">
                                <img src="assets/img/user3.jpg" class="rounded-circle mr-2" alt="image">
                                <span>Dennis Hines</span>
                            </div>
                            <div class="courses-rating">
                                <div class="review-stars-rated">
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                    <i class='bx bxs-star'></i>
                                </div>
                                <div class="rating-total">(0 Rating)</div>
                            </div>
                        </div>
                        <h3><a routerLink="/single-courses" class="d-inline-block">Certified JavaScript with Free Project Course</a></h3>
                    </div>
                    <div class="courses-box-footer">
                        <ul>
                            <li class="students-number">
                                <i class='bx bx-user'></i> 12 étudiants
                            </li>
                            <li class="courses-lesson">
                                <i class='bx bx-book-open'></i> 8 thématiques
                            </li>
                            <li class="courses-time">
                                <i class='bx bx-time-five'></i> 2 Jours
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->

            <!-- <div class="col-lg-12 col-md-12">
                <div class="courses-info-wrap">
                    <p>100+ Cours et formations disponible <a routerLink="/courses-3-columns-style-1">Voir tous les cours</a></p>
                </div>
            </div> -->
        </div>
    </div>
</section>